import BrowserUtil from "../util/BrowserUtil";
import HashUtil from "../util/HashUtil";


class UserState{
    isLoggedIn:boolean=false;
    loginToken:string = "";
    loginUsername:string = "";
    loginResponse?:ILoginResponseData;
    isRestoring?:boolean;
    isECRCUser:boolean=false;
    psapClientID:string = "";
    psapRegionID:string = "";
    psapHandlingMode:string = "";
    suppressMapUpdates:boolean=false;
    isAdminUser:boolean=false;
    loginEmail:string="";
    pk:string="";
    company_id:string=""
    security_group_id="";
    phone_number="";
}


interface ISavedState{
    carryOverToken:string;
    carryOverUsername:string;
    carryOverEmail:string;
}


export interface ILoginResponseData{
    summary:{
        token:string;
        user_rights:{
            [key:string]:any;
        }
        user_role:string;
        username:string;
        pk:string;
        company_id:string;
        security_group_id:string;
        phone_number:string;
    }
}




export class The_User{


    hasLoggedInOnce:boolean=false;
    storageIDGeneral:string = "PSAPLINK_general_11-1-2022_16:14";

    state:UserState;
    savedGeneral:ISavedState;

    deviceID:string;
    pushToken:string;
    
    storage:Storage = window.localStorage;
    loginResponseData?: ILoginResponseData;


    constructor(){
        this.state = new UserState();
        this.pushToken = HashUtil.md5("PSAPLinkWebPushToken");
        this.deviceID = HashUtil.md5(Date.now()+""+(Math.random()*100000000));

        let strData:string | null = this.storage.getItem(this.storageIDGeneral);
        if(strData){
            this.savedGeneral = JSON.parse(strData);
        }else{
            this.savedGeneral = {
                carryOverToken:"",
                carryOverUsername:"",
                carryOverEmail:"",
            }
            this._saveGeneral();
        }
        this.checkRestoration();
    }

    _saveGeneral=()=>{
        const strData:string = JSON.stringify(this.savedGeneral);
        this.storage.setItem(this.storageIDGeneral, strData);
    }

    
    checkRestoration=()=>{
        if(this.savedGeneral.carryOverToken!==""){

            this.state.loginUsername = this.savedGeneral.carryOverUsername;
            this.state.loginToken = this.savedGeneral.carryOverToken;
            this.state.loginEmail = this.savedGeneral.carryOverEmail;
            this.state.isRestoring=true;
            
            //clear carry over token
            this.savedGeneral.carryOverUsername="";
            this.savedGeneral.carryOverToken="";
            this._saveGeneral();
            //this._transitionOverlayShow("Your session is being restored","Please Wait...");
        }else{
            this.state.isRestoring=false;
        }
    }

    applyRestorationAndReload=()=>{
        this.savedGeneral.carryOverUsername = this.state.loginUsername;
        this.savedGeneral.carryOverToken = this.state.loginToken;
        this.savedGeneral.carryOverEmail = this.state.loginEmail;
        this._saveGeneral();
        //give time to make sure saved
        window.setTimeout(()=>{
            //refresh
            window.location.reload();
        },1000);
    }


    login=($email:string, $loginResponse:ILoginResponseData)=>{


        if(!this.hasLoggedInOnce){
            this.hasLoggedInOnce=true;

            let numSecondsForAutoRefresh:number = 43200;//12 hours, we do this because otherwise google maps tiles will expire.

            window.setTimeout(()=>{
                User.applyRestorationAndReload();
            },numSecondsForAutoRefresh*1000);
        }


        this.state.isLoggedIn=true;

        this.state.loginEmail = $email;

        //not saving password just yet
        this.state.loginResponse = $loginResponse;
        this.state.loginToken = $loginResponse.summary.token;
        this.state.isECRCUser = false;
        
        console.log("setting up user")

        if(User.state.loginResponse?.summary.user_rights){
            let rights = User.state.loginResponse.summary.user_rights;

            if(rights["PSAP_CLIENT_ID"]){
                this.state.psapClientID = rights["PSAP_CLIENT_ID"];
            }
            if(rights["PSAP_REGION_ID"]){
                this.state.psapRegionID = rights["PSAP_REGION_ID"];   
            }
            if(rights["PSAP_HANDLING_MODE"]){
                this.state.psapHandlingMode = rights["PSAP_HANDLING_MODE"];
            }
            if(rights["UI_SUPPRESS_MAP_UPDATES"]){
                this.state.suppressMapUpdates = true;
            }
            if(rights["IS_ECRC_USER"]){
                this.state.isECRCUser = true;
            }
            
        }
        
        if(User.state.loginResponse?.summary.user_role){
            let role = User.state.loginResponse.summary.user_role;

            if(role=="ADMIN"){
                this.state.isAdminUser = true;
            }
        }

        if(User.state.loginResponse?.summary.username){
            let name = User.state.loginResponse.summary.username;
            this.state.loginUsername = name;
            
        }

        if(User.state.loginResponse?.summary.pk){
            let pk = User.state.loginResponse.summary.pk;
            this.state.pk = pk;
        }

        if(User.state.loginResponse?.summary.company_id){
            let companyId = User.state.loginResponse.summary.company_id;
            this.state.company_id = companyId;
        }

        if(User.state.loginResponse?.summary.security_group_id){
            let securityGroupId = User.state.loginResponse.summary.security_group_id;
            this.state.security_group_id = securityGroupId;
        }
        if(User.state.loginResponse?.summary.phone_number){
            let phoneNumber = User.state.loginResponse.summary.phone_number;
            this.state.phone_number = phoneNumber;
        }



    }
    logout=()=>{
        this.state = new UserState();
        localStorage.clear();
    }
    
}

const User:The_User = new The_User();
export default User;
